import { Link } from "react-router-dom";
import type { HotItem } from "@/types/content";

function TrendMark({ trend }: { trend: HotItem["trend"] }) {
  if (trend === "new") {
    return (
      <span className="rounded-sm bg-primary-500 px-1.5 py-0.5 text-[10px] font-bold text-background-50">爆</span>
    );
  }
  if (trend === "up") {
    return (
      <span className="flex h-4 w-4 items-center justify-center text-primary-500">
        <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center"></i>
      </span>
    );
  }
  if (trend === "down") {
    return (
      <span className="flex h-4 w-4 items-center justify-center text-secondary-500">
        <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
      </span>
    );
  }
  return (
    <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
      <i className="ri-subtract-line w-4 h-4 flex items-center justify-center"></i>
    </span>
  );
}

function rankStyle(rank: number) {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-accent-500 text-secondary-950";
  if (rank === 3) return "bg-secondary-500 text-background-50";
  return "bg-background-200 text-foreground-700";
}

interface HotRankListProps {
  items: HotItem[];
  limit?: number;
}

export default function HotRankList({ items, limit }: HotRankListProps) {
  const list = limit ? items.slice(0, limit) : items;

  return (
    <ol className="divide-y divide-background-200">
      {list.map((item) => (
        <li key={item.rank}>
          <Link
            to={`/article/${item.linkId}`}
            className="group flex items-center gap-3 py-3.5 transition-colors hover:bg-background-100"
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${rankStyle(item.rank)}`}
            >
              {item.rank}
            </span>
            <span className="flex-1 truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
              {item.keyword}
            </span>
            <span className="hidden shrink-0 rounded-sm bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500 sm:inline-block">
              {item.category}
            </span>
            <TrendMark trend={item.trend} />
            <span className="w-14 shrink-0 text-right text-xs text-foreground-500">{item.heat}</span>
          </Link>
        </li>
      ))}
    </ol>
  );
}